import React from 'react';
import { Layout, Row, Col } from 'antd';
import { makeStyles } from '@material-ui/core/styles';
import { useLocation } from 'react-router-dom';
import CButton from '../../component/Button';
import { CInput } from '../../component/Input';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiFormLabel-root': {
      color: '#000000',
      fontFamily: 'Poppins',
      zIndex: 2
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        backgroundColor: 'white',
        borderColor: '#CAD8FF',
        zIndex: -1
      },
      borderRadius: '10px',
      zIndex: 1
    }
  }
}));

const summaryOptions = [
  { name: 'SubTotal', value: '$500' },
  { name: 'Savings', value: '$20 (-10%)' },
  { name: 'Promo Code', value: '-' }
];

const CouponField = () => {
  const classes = useStyles();

  return (
    <Row style={{ marginTop: '32px' }}>
      <Col>
        <CInput
          classes={{ root: classes.root }}
          id="outlined-flexible"
          label="Promo Code"
          size="small"
          variant="outlined"
          xstyle={{
            borderRadius: '10px',
            width: '100%'
          }}
        />
      </Col>
      <Col>
        <CButton
          size="large"
          style={{
            border: '1px solid #CAD8FF',
            borderRadius: '10px',
            boxSizing: 'border-box',
            height: '40px',
            marginLeft: '12px',
            width: '77px'
          }}
          type="cartBtn"
        >
          Apply
        </CButton>
      </Col>
    </Row>
  );
};

const Cart = () => {
  const location = useLocation();

  return (
    <Layout
      style={{
        backgroundColor: 'white',
        border: '1px solid #CAD8FF',
        borderRadius: '10px',
        boxSizing: 'border-box',
        marginLeft: '32px',
        paddingBottom: '24px',
        paddingLeft: '24px',
        paddingTop: '10px',
        width: '356px'
      }}
    >
      <Row
        style={{
          fontSize: '18px',
          fontWeight: 'bold',
          marginBottom: '8px',
          marginTop: '24px'
        }}
      >
        Order Summary
      </Row>
      <Row style={{ fontSize: '12px', marginBottom: '32px' }}>3 items</Row>

      {summaryOptions.map((i, index) => {
        return (
          <Row
            key={index}
            style={{
              fontSize: '12px',
              justifyContent: 'space-between',
              marginRight: '24px'
            }}
          >
            <Col>{i.name}</Col>
            <Col style={{ fontWeight: 'bold' }}>{i.value}</Col>
          </Row>
        );
      })}

      <Row
        style={{
          fontSize: '16px',
          fontWeight: 'bold',
          justifyContent: 'space-between',
          marginRight: '24px',
          marginTop: '24px'
        }}
      >
        <Col>Total</Col>
        <Col>$500</Col>
      </Row>
      {location.pathname === '/cart' ? <CouponField /> : ''}
      <CButton
        htmlType="submit"
        size="large"
        style={{ borderRadius: '20px', marginTop: '20px', width: '308px' }}
        type="primary"
        // onClick={(e) => onSave(e)}
        // disabled={!isSaveEnabled}
      >
        Proceed to Checkout
      </CButton>
    </Layout>
  );
};

export default Cart;
